import Vue from 'vue';

if (!Vue.__computed_isApp_mixin__) {
  Vue.__computed_isApp_mixin__ = true;
  Vue.mixin({
    computed: {
      $$isApp() {
        // mobile app like iOS, Android
        return this.$$isMobile;
      },
    },
  });
}
if (!Vue.__computed_isMobile_mixin__) {
  Vue.__computed_isMobile_mixin__ = true;
  Vue.mixin({
    computed: {
      $$isMobile() {
        // responsive screen size
        return process.client && window.innerWidth < 1024;
      },
    },
  });
}
if (!Vue.__computed_isTablet_mixin__) {
  Vue.__computed_isTablet_mixin__ = true;
  Vue.mixin({
    computed: {
      $$isTablet() {
        // responsive screen size
        return process.client && window.innerWidth >= 1024;
      },
    },
  });
}
if (!Vue.__computed_isDesktop_mixin__) {
  Vue.__computed_isDesktop_mixin__ = true;
  Vue.mixin({
    computed: {
      $$isDesktop() {
        // responsive screen size
        return !this.$$isMobile;
      },
    },
  });
}
